import { Badge } from "../ui/badge";
import { Bell } from "lucide-react";

const PRIORITY_COLORS = {
  alta: "bg-red-500",
  media: "bg-yellow-500",
  bassa: "bg-green-500"
};

function CalendarDayCell({ dayInfo, dayEvents, isToday, onClick }) {
  const hasEvents = dayEvents.total > 0;
  return (
    <div
      onClick={() => onClick(dayInfo.date)}
      className={`min-h-[100px] p-2 rounded-lg border cursor-pointer transition-all
        ${dayInfo.isCurrentMonth ? 'bg-background hover:bg-muted/50' : 'bg-muted/30 text-muted-foreground'}
        ${isToday ? 'ring-2 ring-primary' : ''}`}
    >
      <div className="flex items-center justify-between mb-1">
        <span className={`text-sm font-medium ${isToday ? 'bg-primary text-primary-foreground rounded-full w-6 h-6 flex items-center justify-center' : ''}`}>
          {dayInfo.day}
        </span>
        {hasEvents && <Badge variant="secondary" className="text-xs h-5 px-1.5">{dayEvents.total}</Badge>}
      </div>
      <div className="space-y-1">
        {dayEvents.attivita.slice(0, 2).map(event => (
          <div key={`a-${event.id}`} className={`text-xs truncate px-1.5 py-0.5 rounded ${PRIORITY_COLORS[event.priorita]} text-white`}>
            {event.titolo}
          </div>
        ))}
        {dayEvents.promemoria.slice(0, 2 - dayEvents.attivita.length).map(event => (
          <div key={`r-${event.id}`} className="text-xs truncate px-1.5 py-0.5 rounded text-white" style={{ backgroundColor: event.colore }}>
            <Bell className="h-2.5 w-2.5 inline mr-1" />{event.titolo}
          </div>
        ))}
        {dayEvents.total > 2 && <div className="text-xs text-muted-foreground">+{dayEvents.total - 2} altri</div>}
      </div>
    </div>
  );
}

const DAYS = ["Lun", "Mar", "Mer", "Gio", "Ven", "Sab", "Dom"];

export function CalendarGrid({ calendarDays, getEventsForDate, onDayClick }) {
  const today = new Date();
  const isSameDay = (d) => d.getDate() === today.getDate() && d.getMonth() === today.getMonth() && d.getFullYear() === today.getFullYear();

  return (
    <>
      <div className="grid grid-cols-7 gap-1 mb-2">
        {DAYS.map(day => (
          <div key={day} className="text-center text-sm font-medium text-muted-foreground py-2">{day}</div>
        ))}
      </div>
      <div className="grid grid-cols-7 gap-1">
        {calendarDays.map((dayInfo) => {
          const dateKey = dayInfo.date.toISOString().split('T')[0];
          return (
            <CalendarDayCell
              key={dateKey}
              dayInfo={dayInfo}
              dayEvents={getEventsForDate(dayInfo.date)}
              isToday={isSameDay(dayInfo.date)}
              onClick={onDayClick}
            />
          );
        })}
      </div>
    </>
  );
}
